// extracted by mini-css-extract-plugin
export default {"mainHeadingText":"HomePage_mainHeadingText__cf6jC","imagHeadingImage":"HomePage_imagHeadingImage__HUE04","mainHeading":"HomePage_mainHeading__6Uaog"};